<template>
  <div class="order-detail-88">
    <loading v-if="loading"></loading>
    <Head>
      <template #header-left>
        <el-button
          class="n-btn"
          type="info"
          @click="$router.push(`/orders/orders-return`)"
        >
          Quay lại 
        </el-button>
      </template>

      <template #title>
        <p>Chi tiết đơn trả hàng</p>
      </template>

      <template #header-right>
        <div>
          <el-button
            class="n-btn" 
            type="danger" plain
            @click="popupCancelRO = true"
            v-if="!(orderHaveExchangeItem) && !isReceivedItem && dataItem.outcomes.length == 0 && statusOrder[1].processorStatus != 'CANCEL'"
          >Hủy đơn
          </el-button>

          <el-button
            class="n-btn" 
            type="danger" plain
            @click="popupCancelRO = true"
            v-if="orderHaveExchangeItem && !isReceivedItem && dataItem.outcomes.length == 0 && statusOrder[1].processorStatus != 'CANCEL' && returnPrice < exchangePrice"
          >Hủy đơn
          </el-button>

          <el-button
            class="n-btn"
            type="primary" plain
            v-if="!(orderHaveExchangeItem) && !(dataItem.furtherInstructions[0].params.paymentStatus == 'PAID_IN_FULL') && refundPolicy && statusOrder[1].processorStatus != 'CANCEL'"
            @click="popupRepay = true"
          >
            Hoàn tiền cho khách
          </el-button>

          <el-button
            class="n-btn" 
            type="primary" plain
            @click="popupMCmustPay = true"
            v-if="orderHaveExchangeItem && !(dataItem.furtherInstructions[0].params.paymentStatus == 'PAID_IN_FULL') && refundPolicy && refundType == 'MERCHANT_PAY' && statusOrder[1].processorStatus != 'CANCEL'"
          >
            Xác nhận thanh toán
          </el-button>

          <el-button
            class="n-btn" 
            type="primary" plain
            @click="popupCTmustPay = true"
            v-if="orderHaveExchangeItem && !(dataItem.furtherInstructions[0].params.paymentStatus == 'PAID_IN_FULL') && refundType == 'CUSTOMER_PAY' && statusOrder[1].processorStatus != 'CANCEL'"
          >
            Xác nhận thanh toán
          </el-button>

          <el-button
            class="n-btn" 
            type="primary"
            v-if="!isReceivedItem && statusOrder[1].processorStatus != 'CANCEL'"
            @click="popupConfirmItemReceived = true"
          >
            Nhận hàng trả
          </el-button>
        </div>
      </template>
    </Head>

    <div class="boxContent boxContentExt">
      <div class="boxProgress">
        <el-steps class="n-steps" :active="statusActive" align-center>
          <el-step  v-for="(status, index) in statusOrder"  :key="index"   :title="status.statusTitle" :description="status.description"
            :class="status.processorStatus == 'CANCEL' ? 'cancel' : ''" :icon="status.processorStatus == 'CANCEL' ? 'el-icon-close' : ''"></el-step>
        </el-steps>

        <!-- <el-steps :active="statusActive" align-center>
          <el-step 
            v-for="(status, index) in statusOrder" 
            :key="index"
            :description="status.description"
            :title="status.statusTitle"
            :icon="status.processorStatus == 'CANCEL' ? 'el-icon-circle-close' : ''"
            >
          </el-step>
        </el-steps> -->
      </div>
    </div>

    <div class="boxContent boxContentExt">
      <div class="__card">
        <h1 class="__card_title">Thông tin đơn mua hàng</h1>
        <el-form label-width="140px" style="width: 100%;" :inline="true">
          <el-row>
            <el-col :span="24">
              <el-form-item label="Mã đơn hàng" class="m-0">
                <strong class="mr-3"> {{ dataReturnOrder[0].params.soOrderNo }}</strong>
                <a class="text-primary cursor" @click="linkTo()">
                  <i class="fa-solid fa-up-right-from-square mr-1"></i> Đi đến đơn hàng
                </a>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Khách hàng" class="mb-0">
                <strong> {{ checkEmpty(dataItem.partyB.displayName) }}</strong>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Ngày mua" label-width="160px" class="mb-0">
                <span>{{ checkEmpty(this.timeFormatDate(dataItem.createdAt)) }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Chi nhánh" class="mb-0">
                <span>{{ checkEmpty(dataReturnOrder[0].params.soLocationName) }}</span>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Nhân viên bán hàng" label-width="160px" class="mb-0">
                <span>{{ checkEmpty(dataItem.partyA.displayName) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="boxContent boxContentExt">
      <div class="__card">
        <h1 class="__card_title">Thông tin đơn trả</h1>
        <el-form label-width="140px" style="width: 100%;" :inline="true">
          <el-row>
            <el-col :span="12">
              <el-form-item label="Mã đơn trả" class="mb-0">
                <span>{{checkEmpty(dataItem.orderNo)}}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Người tạo đơn" class="mb-0">
                <span>{{ checkEmpty(dataItem.partyA.displayName) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Ngày tạo" label-width="160px" class="mb-0">
                <span>{{ checkEmpty(this.timeFormatDate(dataItem.createdAt)) }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Khách trả hàng" class="mb-0">
                <span>{{ checkEmpty(par.customerName) }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Lý do trả" label-width="160px" class="mb-0">
                <span>{{ checkEmpty(par.returnReason) }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Mã tham chiếu" class="mb-0">
                <span>{{ checkEmpty(par.referenceCode) }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="Ghi chú" class="mb-0">
                <span>{{ checkEmpty(par.note) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="boxContent boxContentExt">
      <div class="__card">
        <h1 class="__card_title">Lịch sử thao tác</h1>
        <el-row>
          <el-table :data="dataHistory" style="width: 100%">
            <el-table-column label="" width="50" type="index" align="center"></el-table-column>
            <el-table-column
               label="Thời gian"
               width="300"
            >
              <template slot-scope="scope">
                {{ checkEmpty(scope.row.modifiedAt) }}
              </template>
            </el-table-column>
            <el-table-column
               label="Thao tác"
               width="300"
               prop="action"
            >
            </el-table-column>
            <el-table-column
               label="Người thực hiện"
               width="250"
               prop="modifiedByName"
            >
            </el-table-column>
          </el-table>
        </el-row>
      </div>
    </div>

    <b-card class="form-card" style="width: 960px; margin:12px auto;">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="Sản phẩm trả" name="first">
            <el-row class="w-100">
              <!-- table -->
            <b-table :items="dataReturn" :fields="fields" :key="updateUI" show-empty>
                <template #empty>
                  <div class="text-align-center">
                    <p>Chưa có sản phẩm nào được chọn.</p>
                  </div>
                </template>
                <template #cell(stt)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(sku)="data">
                  {{ data.item.itemInstance.moreInformation.sku }}
                </template>
                <template #cell(itemName)="data">
                  {{ data.item.itemInstance.name }}
                </template>
                <template #cell(price)="data">
                  <div class="position-relative">
                    {{formatMoneyNotUnit(Math.floor(data.item.unitPrice/1000))}}
                    <span v-if="data.item.productFeeValue" class="fee-value">{{formatMoneyNotUnit(data.item.productFeeValue / 1000)}}</span>
                  </div>
                </template>
                <template #cell(total)="data">
                  {{formatMoneyNotUnit(Math.floor(data.item.itemTotalPrice / 1000 + (data.item.productFeeValue * data.item.quantity) / 1000))}}
                </template>
                <template #row-details="data">
                  <!--Chọn số EMEI/se-ri: useImeiAndSerial-->
                  <div class="line dataUseImeiAndSerial" v-if="data.item.useImeiAndSerial">
                    <div class="col-md-2 text-bold pull-left mt-2">IMEI/Serial:</div>
                    <div class="col-md-10 pull-left selectDT">
                      <div class="select-item" v-for="(item, i) in data.item.lineItemOtherInfo.seriesNo" :key="i">
                        {{item}}
                      </div>
                    </div>
                  </div>
                  <!--Chọn số Lo/HSD: useProductBatch-->
                  <div class="line dataUseProductBatch" v-if="data.item.useProductBatch">
                    <div class="col-md-2 text-bold pull-left mt-2">Lô HSD:</div>
                    <div class="col-md-10 pull-left selectLoHsd">
                      <div>
                        <div class="select-item" v-for="(itemBatch, indexBatch) in data.item.batchTmp" :key="indexBatch">
                          {{ itemBatch.batchCode }} - HSD: {{ convertDateItem(itemBatch.expirationDate) }} - SL:
                          {{ itemBatch.quantityVal }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
            </b-table>
              <!-- end table -->
            </el-row>
            <el-row class="w-100">
              <el-col :span="12">
                <div>
                  <p>Đã chọn <span>{{dataReturn.length}}</span> sản phẩm</p>
                  <p>Đã nhận hàng trả
                    <el-switch
                      disabled
                      class="mx-3"
                      active-text="Nhận hàng"
                      v-model="isReceivedItem">
                    </el-switch>
                  </p>
                </div>
              </el-col>
              <el-col :span="12">
                <el-row class="mb-0">
                  <el-col :span="12" style="text-align: right">
                    <p>Tạm tính</p>
                  </el-col>
                  <el-col :span="12" style="text-align: right">
                    <span>{{ formatMoneyNotUnit( Math.floor(temporaryAmount) )}}</span>
                  </el-col>
                </el-row>
                <el-row class="mb-0">
                  <el-col :span="12" style="text-align: right">
                    <p>Phí trả hàng</p>
                  </el-col>
                  <el-col :span="12" style="text-align: right">
                    <span>{{dataItem.lineItemFinalizing.addedFee.length > 0 ? formatMoneyNotUnit(Math.floor(dataItem.lineItemFinalizing.addedFee[0].amount / 1000)) : 0 }}</span>
                  </el-col>
                </el-row>
                <el-row class="mb-0 border-top">
                  <el-col :span="12" style="text-align: right">
                    <span style="line-height: 40px">Tổng tiền hàng trả</span>
                  </el-col>
                  <el-col :span="12" style="text-align: right">
                    <span style="font-weight: bold; line-height: 40px">{{formatMoneyNotUnit(Math.floor(dataItem.lineItemFinalizing.finalAmount / 1000 ))}}</span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
        </el-tab-pane>
        <el-tab-pane label="Sản phẩm đổi" :disabled="!orderHaveExchangeItem" name="second">
            <el-row class="w-100">
              <b-table :items="dataReturnHaveExchangeItem" :fields="fields" :key="updateUI" show-empty>
                <template #empty>
                  <div class="text-align-center">
                    <p>Chưa có sản phẩm nào được đổi.</p>
                  </div>
                </template>
                <template #cell(stt)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(sku)="data">
                  {{ data.item.itemInstance.moreInformation.sku }}
                </template>
                <template #cell(itemName)="data">
                  {{ data.item.itemInstance.name }}
                </template>
                <template #cell(price)="data">
                  <div class="position-relative">
                    {{formatMoneyNotUnit(Math.floor(data.item.unitPrice/1000))}}
                    <span v-if="data.item.productFeeValue" class="fee-value">{{formatMoneyNotUnit(Math.floor((data.item.productFeeValue / 1000)))}}</span>
                  </div>
                </template>
                <template #cell(total)="data">
                  {{formatMoneyNotUnit(Math.floor(data.item.itemTotalPrice / 1000 - (data.item.productFeeValue * data.item.quantity) / 1000))}}
                </template>
                <template #row-details="data">
                  <!--Chọn số EMEI/se-ri: useImeiAndSerial-->
                  <div class="line dataUseImeiAndSerial" v-if="data.item.useImeiAndSerial">
                    <div class="col-md-2 text-bold pull-left mt-2">IMEI/Serial:</div>
                    <div class="col-md-10 pull-left selectDT">
                      <div class="select-item" v-for="(item, i) in JSON.parse(data.item.lineItemOtherInfo.seriesNo)" :key="i">
                        {{item}}
                      </div>
                    </div>
                  </div>
                  <!--Chọn số Lo/HSD: useProductBatch-->
                  <div class="line dataUseProductBatch" v-if="data.item.useProductBatch">
                    <div class="col-md-2 text-bold pull-left mt-2">Lô HSD:</div>
                    <div class="col-md-10 pull-left selectLoHsd">
                      <div>
                        <div class="select-item" v-for="(itemBatch, indexBatch) in data.item.batchTmp" :key="indexBatch">
                          {{ itemBatch.batchCode }} - HSD: {{ convertDateItem(itemBatch.expirationDate) }} - SL:
                          {{ itemBatch.quantityVal }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </b-table>
            </el-row>
            <el-row class="w-100"
              style="display: flex;flex-direction: row-reverse;"
            >
              <el-col :span="12">
                <div class="row py-1 justify-content-end text-right">
                  <div class="col-6">Tổng tiền ({{ totalQuantity }} sản phẩm)</div>
                  <!-- <div class="col-2">{{ (orderData.lineItemAgg.netSubTotal) }}</div> -->
                  <div class="col-3">{{ formatMoneyNotUnit(Math.floor((divisionThousand(totalAmount)))) }}</div>
                </div>
                <div class="row py-1 justify-content-end text-right">
                  <div class="col-6">Thuế tổng đơn ({{ tax | formatPercent }}%)</div>
                  <div class="col-3">{{ formatMoneyNotUnit(Math.floor((divisionThousand(taxAmount)))) }}</div>
                </div>
                <div class="row py-1 justify-content-end text-right">
                  <div class="col-6">Chiết khấu ({{ discont | formatPercent }}%)</div>
                  <div class="col-3">{{ formatMoneyNotUnit(Math.floor((divisionThousand(discontAmount)))) }}</div>
                </div>
                <div class="row py-1 justify-content-end text-right">
                  <div class="col-6">Phí dịch vụ</div>
                  <div class="col-3">{{ formatMoneyNotUnit(Math.floor((divisionThousand(feeAmount)))) }}</div>
                </div>
                <div class="row justify-content-end">
                  <div class="col-5 border-bottom"></div>
                </div>
                <div class="row py-1 justify-content-end text-right">
                  <div class="col-6">Tổng tiền</div>
                  <div class="col-3">
                    <b>{{ formatMoneyNotUnit(Math.floor((exchangePrice)))}}</b>
                  </div>
                </div>
              </el-col>
            </el-row>
        </el-tab-pane>
      </el-tabs>
      <span v-if="orderHaveExchangeItem">
        <BottomPrice :returnPrice="returnPrice" :exchangePrice="exchangePrice"></BottomPrice>
      </span>
    </b-card>

    <div class="boxContent boxContentExt">
      <div class="__card">
        <div v-if="!willCustomerPay" style="width:100%">
          <div v-if="refundPolicy">
            <h1 class="__card_title">Hoàn tiền cho khách</h1>
            <span v-if=" orderHaveExchangeItem && !(dataItem.furtherInstructions[0].params.paymentStatus == 'PAID_IN_FULL')">
              <el-form :inline="true" class="my-0">
                <el-form-item label="Tổng phải hoàn" class="mb-0" label-width="150px">
                  <span style="font-weight: bold;">{{ formatMoneyNotUnit(Math.floor((totalAmountToPay - repayNetSubTotal / 1000))) }} đ</span>
                </el-form-item>
              </el-form>
              <el-form :inline="true" class="my-0">
                <el-form-item label="Thêm số tiền hoàn" class="mb-0" label-width="150px">
                  <el-select
                    v-model="repayItem.repayMethod"
                    placeholder="Chọn phương thức"
                    class="el" style="width:100%">
                      <el-option
                        v-for="(payMethod, index) in merchantPayMethodList"
                        :key="index"
                        :label="payMethod.text"
                        :value="payMethod.value">
                      </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <InputMoneyVmodel
                    customClass="h-40"
                    placeholder="Nhập số tiền..."
                    v-model="repayItem.repayAmount"
                    :max="Math.floor(this.totalAmountToPay - this.repayNetSubTotal / 1000)"
                    class="form-control"
                    >
                  </InputMoneyVmodel>
                  <!-- <el-input
                    v-model="repayItem.repayAmount"
                    @input="inputMoney(), checkMaxValue(repayItem.repayAmount)"
                    clearable
                    placeholder="0"
                  /> -->
                </el-form-item>
                <el-form-item>
                  <el-input placeholder="Mã tham chiếu" v-model="gatewayTransactionId"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button :disabled="!repayItem.repayMethod || repayItem.repayAmount <= 0" type="primary" plain @click="addRepayItemHaveExchange(repayItem.repayAmount, repayItem.repayMethod)">Thêm</el-button>
                </el-form-item>
              </el-form>
            </span>
            <span v-else-if=" !orderHaveExchangeItem && !(dataItem.furtherInstructions[0].params.paymentStatus == 'PAID_IN_FULL')">
              <el-form :inline="true" class="my-0">
                <el-form-item label="Tổng phải hoàn" class="mb-0" label-width="150px">
                  <span style="font-weight: bold;">{{ formatMoneyNotUnit(Math.floor(totalAmountToPay - repayNetSubTotal / 1000)) }} đ</span>
                </el-form-item>
              </el-form>
              <el-form :inline="true" class="my-0">
                <el-form-item label="Thêm số tiền hoàn" class="mb-0" label-width="150px">
                  <el-select
                    v-model="repayItem.repayMethod"
                    placeholder="Chọn phương thức"
                    class="el" style="width:100%">
                      <el-option
                        v-for="(payMethod, index) in merchantPayMethodList"
                        :key="index"
                        :label="payMethod.text"
                        :value="payMethod.value">
                      </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                   <InputMoneyVmodel
                    customClass="h-40"
                    placeholder="Nhập số tiền..."
                    v-model="repayItem.repayAmount"
                    :max="Math.floor(this.totalAmountToPay - this.repayNetSubTotal / 1000)"
                    class="form-control h-100"
                    >
                  </InputMoneyVmodel>
                  <!-- <el-input
                    v-model="repayItem.repayAmount"
                    @input="inputMoney(), checkMaxValue(repayItem.repayAmount)"
                    clearable
                    placeholder="0"
                  /> -->
                </el-form-item>
                <el-form-item>
                  <el-input placeholder="Mã tham chiếu" v-model="gatewayTransactionId"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button :disabled="!repayItem.repayMethod || repayItem.repayAmount <= 0" type="primary" plain @click="addRepayItem(repayItem.repayAmount, repayItem.repayMethod)">Thêm</el-button>
                </el-form-item>
              </el-form>
            </span>
            
            <el-row style="padding-bottom:20px">
              <el-table :data="dataRepay" style="width: 100%">
                <el-table-column label="#" width="50" type="index" align="center"></el-table-column>
                <el-table-column
                  label="Thời gian"
                  width="180"
                >
                  <template slot-scope="scope">
                    {{ scope.row.date }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Người thực hiện"
                  width="160"
                  prop="name"
                >
                  <template slot-scope="scope">
                    {{ checkEmpty(scope.row.name) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Phương thức"
                  width="120"
                  prop="payMethod"
                >
                  <template slot-scope="scope">
                    {{ getRepayMethod(scope.row.payMethod) }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Số tiền hoàn"
                  width="160"
                  align="right"
                >
                  <template slot-scope="scope">
                    {{ formatMoneyNotUnit(Math.floor(scope.row.amount / 1000)) }}
                    <!-- {{formatMoneyNotUnit(scope.row.amount / 1000 )}} -->
                  </template>
                </el-table-column>
                <el-table-column
                  label="Mã tham chiếu"
                  width="220"
                  prop="refCode"
                >
                  <template slot-scope="scope">
                    {{ checkEmpty(scope.row.refCode) }}
                    <!-- {{formatMoneyNotUnit(scope.row.amount / 1000 )}} -->
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
            <el-row style="width:100%" :gutter="24">
              <el-col :span="12" :offset="12">
                <template v-if="orderHaveExchangeItem">
                  <el-row class="mb-0">
                    <el-col :span="12" style="text-align: right">
                      <p>Tổng tiền hàng trả</p>
                    </el-col>
                    <el-col :span="12" style="text-align: right">
                      <span style="font-weight: bold;"> {{ formatMoneyNotUnit(Math.floor(returnPrice)) }} đ</span>
                    </el-col>
                  </el-row>
                  <el-row class="mb-0">
                    <el-col :span="12" style="text-align: right">
                      <p>Tổng tiền hàng đổi</p>
                    </el-col>
                    <el-col :span="12" style="text-align: right">
                      <span style="font-weight: bold;"> {{ formatMoneyNotUnit(Math.floor(exchangePrice)) }} đ</span>
                    </el-col>
                  </el-row>
                </template>

                <el-row v-if="returnPrice - exchangePrice > 0" class="mb-0" :class="orderHaveExchangeItem ? 'border-top' : ''">
                  <el-col :span="12" style="text-align: right">
                    <p>Tổng phải hoàn</p>
                  </el-col>
                  <el-col :span="12" style="text-align: right">
                    <span style="font-weight: bold;">{{ formatMoneyNotUnit(Math.floor(Math.abs(totalAmountToPay))) }} đ</span>
                  </el-col>
                </el-row>

                <el-row v-else class="mb-0" :class="orderHaveExchangeItem ? 'border-top' : ''">
                  <el-col :span="12" style="text-align: right">
                    <p>Khách phải trả</p>
                  </el-col>
                  <el-col :span="12" style="text-align: right">
                    <span style="font-weight: bold;">{{ formatMoneyNotUnit(Math.floor(Math.abs(totalAmountToPay))) }} đ</span>
                  </el-col>
                </el-row>

                <el-row class="mb-0">
                  <el-col :span="12" style="text-align: right">
                    <p>Đã thanh toán</p>
                  </el-col>
                  <el-col :span="12" style="text-align: right">
                    <span> {{ this.repayNetSubTotal ? formatMoneyNotUnit(Math.floor(repayNetSubTotal / 1000)) : 0 }} đ</span>
                  </el-col>
                </el-row>
                <el-row class="mb-0 border-top">
                  <el-col :span="12" style="text-align: right">
                    <span style="line-height: 40px">Còn lại</span>
                  </el-col>
                  <el-col :span="12" style="text-align: right">
                    <span style="font-weight: bold; line-height: 40px">{{ formatMoneyNotUnit(Math.floor(totalAmountToPay - repayNetSubTotal / 1000)) }} đ</span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <div v-if="!refundPolicy" class="row w-100 d-flex justify-content-center">
          <div class="col-10">
            <b-alert class="custom-alert" show variant="warning text-dark">
              Giá trị cần hoàn trả bằng 0 do cửa hàng đã bật cấu hình <b>“Không hoàn tiền khi đổi trả hàng”</b>.<br />
              Để cài đặt lại, vui lòng đi tới <b><router-link :to="{ path: '/setting/config' }">Cấu hình bán hàng</router-link></b>
            </b-alert>
          </div>
        </div>
        </div>
          <div v-else style="width:100%">
            <div v-if="!refundPolicy" class="row w-100 d-flex justify-content-center">
              <div class="col-10">
                <b-alert class="custom-alert" show variant="warning text-dark">
                  Giá trị cần hoàn trả bằng 0 do cửa hàng đã bật cấu hình <b>“Không hoàn tiền khi đổi trả hàng”</b>.<br />
                  Để cài đặt lại, vui lòng đi tới <b><router-link :to="{ path: '/setting/config' }">Cấu hình bán hàng</router-link></b>
                </b-alert>
              </div>
            </div>
            <div v-if="refundPolicy" style="width:100%">
              <h1 class="__card_title">Khách thanh toán</h1>
              <span v-if="!(dataItem.furtherInstructions[0].params.paymentStatus == 'PAID_IN_FULL')">
                <el-form :inline="true" class="my-0">
                  <el-form-item label="Khách phải trả" class="mb-0" label-width="150px">
                    <span style="font-weight: bold;">{{ formatMoneyNotUnit(Math.floor(totalAmountToPay - repayNetSubTotal / 1000)) }} đ</span>
                  </el-form-item>
                </el-form>
                <el-form :inline="true" class="my-0">
                  <el-form-item label="Khách thanh toán" class="mb-0" label-width="150px">
                    <el-select
                      v-model="repayItem.repayMethod"
                      placeholder="Chọn phương thức"
                      class="el" style="width:100%">
                        <el-option
                          v-for="(payMethod, index) in customerPayMethodList"
                          :key="index"
                          :label="payMethod.text"
                          :value="payMethod.value">
                        </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="repayItem.repayAmount"
                      @input="inputMoney(), checkMaxValue(repayItem.repayAmount)"
                      clearable
                      placeholder="0"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-input placeholder="Mã tham chiếu" v-model="gatewayTransactionId"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" plain @click="addRepayItemHaveExchange(repayItem.repayAmount, repayItem.repayMethod)">Thêm</el-button>
                  </el-form-item>
                </el-form>
              </span>
              
              <el-row>
                <el-table :data="dataRepay" style="width: 100%">
                  <el-table-column label="#" width="50" type="index" align="center"></el-table-column>
                  <el-table-column
                    label="Thời gian"
                    width="180"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.date }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Người thực hiện"
                    width="160"
                    prop="name"
                  >
                    <template slot-scope="scope">
                      {{ checkEmpty(scope.row.name) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Phương thức"
                    width="120"
                    prop="payMethod"
                  >
                    <template slot-scope="scope">
                      {{ getRepayMethod(scope.row.payMethod) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Số tiền hoàn"
                    width="160"
                    align="right"
                  >
                    <template slot-scope="scope">
                      {{ formatMoneyNotUnit(Math.floor(scope.row.amount / 1000)) }}
                      <!-- {{formatMoneyNotUnit(scope.row.amount / 1000 )}} -->
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Mã tham chiếu"
                    width="220"
                    prop="refCode"
                  >
                    <template slot-scope="scope">
                      {{ checkEmpty(scope.row.refCode) }}
                      <!-- {{formatMoneyNotUnit(scope.row.amount / 1000 )}} -->
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
              <el-row style="width:100%" :gutter="24">
                <el-col :span="12" :offset="12">
                  <template v-if="orderHaveExchangeItem">
                    <el-row class="mb-0" style="padding-top:20px">
                      <el-col :span="12" style="text-align: right">
                        <p>Tổng tiền hàng trả</p>
                      </el-col>
                      <el-col :span="12" style="text-align: right">
                        <span style="font-weight: bold;"> {{ formatMoneyNotUnit(Math.floor(returnPrice)) }} đ</span>
                      </el-col>
                    </el-row>
                    <el-row class="mb-0">
                      <el-col :span="12" style="text-align: right">
                        <p>Tổng tiền hàng đổi</p>
                      </el-col>
                      <el-col :span="12" style="text-align: right">
                        <span style="font-weight: bold;"> {{ formatMoneyNotUnit(Math.floor(exchangePrice)) }} đ</span>
                      </el-col>
                    </el-row>
                  </template>

                  <el-row v-if="returnPrice - exchangePrice > 0" class="mb-0 border-top">
                    <el-col :span="12" style="text-align: right">
                      <p>Tổng phải hoàn</p>
                    </el-col>
                    <el-col :span="12" style="text-align: right">
                      <span style="font-weight: bold;">{{ formatMoneyNotUnit(Math.floor(Math.abs(totalAmountToPay))) }} đ</span>
                    </el-col>
                  </el-row>

                  <el-row v-else class="mb-0 border-top">
                    <el-col :span="12" style="text-align: right">
                      <p>Khách phải trả</p>
                    </el-col>
                    <el-col :span="12" style="text-align: right">
                      <span style="font-weight: bold;">{{ formatMoneyNotUnit(Math.floor(Math.abs(totalAmountToPay))) }} đ</span>
                    </el-col>
                  </el-row>

                  <el-row class="mb-0">
                    <el-col :span="12" style="text-align: right">
                      <p>Đã thanh toán</p>
                    </el-col>
                    <el-col :span="12" style="text-align: right">
                      <span> {{ this.repayNetSubTotal ? formatMoneyNotUnit(Math.floor(repayNetSubTotal / 1000)) : 0 }} đ</span>
                    </el-col>
                  </el-row>
                  <el-row class="mb-0 border-top">
                    <el-col :span="12" style="text-align: right">
                      <span style="line-height: 40px">Còn lại</span>
                    </el-col>
                    <el-col :span="12" style="text-align: right">
                      <span style="font-weight: bold; line-height: 40px">{{ formatMoneyNotUnit(Math.floor(totalAmountToPay - repayNetSubTotal / 1000)) }} đ</span>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
      </div>
    </div>

    <el-dialog
      title="Hủy đơn trả hàng"
      :visible.sync="popupCancelRO"
      width="40%"
    >
      <div class="text-center">
        <img src="@/assets/images/icon-discard-file.svg" alt="icon">
        <p class="mb-0">Bạn có xác nhận huỷ đơn trả hàng này?</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="popupCancelRO = false">Quay lại</el-button>
        <b-overlay
          :show="busy"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block loading-btn"
        >
          <el-button
            type="danger"
            :disabled="busy"
            @click="cancelRO"
          >
            Hủy đơn
          </el-button>
        </b-overlay>
      </span>
    </el-dialog>

    <el-dialog custom-class="n-modal" title="Xác nhận đã nhận hàng trả" width="600px" :visible.sync="popupConfirmItemReceived">
      <div class="text-center">
        <div class="image" style="height: 120px">
          <img src="@/assets/images/icon-box.svg" alt="icon">
        </div>
        <div class="mt-3">Xác nhận đã nhận được hàng trả?</div>
      </div>
      <div slot="footer">
        <el-button class="n-btn" @click="popupConfirmItemReceived = false">Quay lại</el-button>
        <el-button class="n-btn" :loading="busy" @click="btnConfirmReceivedItem" plain type="primary"> Xác nhận</el-button>
      </div>
    </el-dialog>

    <!-- <el-dialog
      title="Xác nhận đã nhận hàng trả"
      :visible.sync="popupConfirmItemReceived"
      width="40%"
    >
      <div class="text-center">
        <img src="@/assets/images/icon-box.svg" alt="icon">
        <p class="mb-0">Xác nhận đã nhận được hàng trả?</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="popupConfirmItemReceived = false">Quay lại</el-button>
        <b-overlay
          :show="busy"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block loading-btn"
        >
          <el-button type='primary' :disabled="busy" @click="btnConfirmReceivedItem">
            Xác nhận
          </el-button>
        </b-overlay>
      </span>
    </el-dialog> -->

    <el-dialog append-to-body :visible.sync="popupRepay" :title="'Hoàn tiền cho khách'" width="800px" :close-on-click-modal="false">
            <!-- <p style="color: #23313E;width: 560px;height: 20px;font-weight: 600;font-size: 16px;line-height: 20px;">Hoàn tiền cho khách</p> -->
        <div class="payment-info"> 
            <div class="row px-3 d-flex justify-content-between">
                <span>Tổng phải hoàn</span>
                <span>{{formatMoneyNotUnit(Math.floor(dataItem.lineItemFinalizing.finalAmount / 1000))}}</span>
            </div>
            <div class="row px-3 d-flex justify-content-between">
                <span>Đã hoàn</span>
                <span>{{ this.repayNetSubTotal ? formatMoneyNotUnit(Math.floor(this.repayNetSubTotal / 1000)) : 0 }}</span>
            </div>
            <div class="row px-3 d-flex justify-content-between total-paid-amount-left">
                <span>Còn lại phải hoàn</span>
                <span>{{ formatMoneyNotUnit(Math.floor(getRepayRemain)) }}</span>
            </div>
        </div>
        <div class="payment-status">
            <div>
              <div
                style="display:flex;flex-direction:column"
              >
                  <span>Phương thức thanh toán</span>
                  <el-select
                    v-model="repayItem.repayMethod"
                    placeholder="Chọn phương thức"
                    class="el">
                      <el-option
                        v-for="(payMethod, value) in merchantPayMethodList"
                        :key="value"
                        :label="payMethod.text"
                        :value="payMethod.value">
                      </el-option>
                  </el-select>
              </div>
            </div>
            <div>
              <span>Số tiền hoàn</span>
                <InputMoneyVmodel
                  customClass="h-40"
                  placeholder="Nhập số tiền..."
                  v-model="repayItem.repayAmount"
                  :max="Math.floor(this.totalAmountToPay - this.repayNetSubTotal / 1000)"
                  class="form-control"
                  >
                </InputMoneyVmodel>
                <!-- <el-input 
                  v-model="repayItem.repayAmount"
                  @input="inputMoney(), checkMaxValue(repayItem.repayAmount)"
                  clearable
                  placeholder="0"
              /> -->
            </div>
            <div>
                <span>Mã tham chiếu</span>
                <el-input 
                    v-model="gatewayTransactionId" 
                    maxlength="50"
                    clearable
                    placeholder="Nhập mã"
                />
            </div>
          </div>
        <template slot='footer'>
            <el-button type='text' @click="popupRepay = false">Thoát</el-button>
            <b-overlay
              :show="busy"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block loading-btn"
            >
              <el-button type="primary" v-if="this.repayItem.repayAmount == 0 || this.repayItem.repayMethod == ''" disabled>Thêm</el-button>
              <el-button type='primary' :disabled="busy" @click="addRepayItem(repayItem.repayAmount,repayItem.repayMethod)" v-else>
                  Thêm
              </el-button>
            </b-overlay>
        </template>
    </el-dialog>

    <el-dialog append-to-body :visible.sync="popupCTmustPay" :title="'Khách thanh toán'" width="600px" :close-on-click-modal="false">
      <div style="display:flex">
        <div class="payment-status">
            <div>
              <div>
                <span>Phương thức thanh toán</span>
                <el-select
                  v-model="repayItem.repayMethod"
                  placeholder="Chọn phương thức"
                  class="el">
                    <el-option
                      v-for="(payMethod, value) in customerPayMethodList"
                      :key="value"
                      :label="payMethod.text"
                      :value="payMethod.value">
                    </el-option>
                </el-select>
            </div>
          </div>
          <div>
            <span>Số tiền hoàn</span>
              <InputMoneyVmodel
                customClass="h-40"
                placeholder="Nhập số tiền..."
                v-model="repayItem.repayAmount"
                :max="Math.floor(this.totalAmountToPay - this.repayNetSubTotal / 1000)"
                class="form-control"
                >
              </InputMoneyVmodel>
              <!-- <el-input
                v-model="repayItem.repayAmount"
                @input="inputMoney(), checkMaxValue(repayItem.repayAmount)"
                clearable
                placeholder="0"
            /> -->
          </div>
          <div>
              <span>Mã tham chiếu</span>
              <el-input 
                  v-model="gatewayTransactionId" 
                  maxlength="50"
                  clearable
                  placeholder="Nhập mã"
              />
          </div>
        </div>
      </div>
      <div class="MPOS-payment" v-if="repayItem.repayMethod == 'MPOS'">
        <div style="display: flex; align-items: flex-start;">
          <img src="@/assets/images/Payment_Mpos.png" style="width:24px; height: 24px; margin-right: 8px" alt="">
          <p style="font-weight: 600;font-size: 16px;">Hướng dẫn thanh toán</p>
        </div>
        <div>
            <span>Nhập mã "<b>MPOS</b>" trên ứng dụng MPOS để thanh toán số tiền này</span>
        </div>
      </div>
      <template slot='footer'>
          <el-button type='text' @click="popupCTmustPay = false">Thoát</el-button>
          <b-overlay
            :show="busy"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
            class="d-inline-block loading-btn"
          >
            <el-button type="primary" v-if="this.repayItem.repayAmount == 0 || this.repayItem.repayMethod == ''" disabled>Thêm</el-button>
            <el-button type='primary' :disabled="busy" @click="addRepayItemHaveExchange(repayItem.repayAmount, repayItem.repayMethod)" v-else>
                Thêm
            </el-button>
          </b-overlay>
      </template>
    </el-dialog>

    <el-dialog custom-class="n-modal" title="Hoàn tiền" width="600px" :visible.sync="popupMCmustPay">
      <!-- body -->
      <div class="payment-status">
          <div>
            <div>
              <span>Phương thức thanh toán</span>
              <el-select
                v-model="repayItem.repayMethod"
                placeholder="Chọn phương thức"
                class="el">
                  <el-option
                    v-for="(payMethod, value) in merchantPayMethodList"
                    :key="value"
                    :label="payMethod.text"
                    :value="payMethod.value">
                  </el-option>
              </el-select>
          </div>
        </div>
        <div>
          <span>Số tiền hoàn</span>
            <InputMoneyVmodel
              customClass="h-40"
              placeholder="Nhập số tiền..."
              v-model="repayItem.repayAmount"
              :max="Math.floor(this.totalAmountToPay - this.repayNetSubTotal / 1000)"
              class="form-control"
              >
            </InputMoneyVmodel>
        </div>
        <div>
            <span>Mã tham chiếu</span>
            <el-input 
                v-model="gatewayTransactionId" 
                maxlength="50"
                clearable
                placeholder="Nhập mã"
            />
        </div>
      </div>
      <div slot="footer">
        <el-button class="n-btn" @click="popupMCmustPay = false">Thoát</el-button>
        <el-button :loading="busy" :disabled="repayItem.repayAmount == 0 || repayItem.repayMethod == ''" class="n-btn" type="primary" @click="addRepayItemHaveExchange(repayItem.repayAmount, repayItem.repayMethod)">Thêm</el-button>
      </div>
    </el-dialog>

    <!-- <el-dialog append-to-body :visible.sync="popupMCmustPay" :title="'Hoàn tiền'" width="600px" :close-on-click-modal="false">
        <div style="display:flex">
        <div class="payment-status">
            <div>
              <div>
                <span>Phương thức thanh toán</span>
                <el-select
                  v-model="repayItem.repayMethod"
                  placeholder="Chọn phương thức"
                  class="el">
                    <el-option
                      v-for="(payMethod, value) in merchantPayMethodList"
                      :key="value"
                      :label="payMethod.text"
                      :value="payMethod.value">
                    </el-option>
                </el-select>
            </div>
          </div>
          <div>
            <span>Số tiền hoàn</span>
              <el-input
                v-model="repayItem.repayAmount"
                @input="inputMoney(), checkMaxValue(repayItem.repayAmount)"
                clearable
                placeholder="0"
            />
          </div>
          <div>
              <span>Mã tham chiếu</span>
              <el-input 
                  v-model="gatewayTransactionId" 
                  maxlength="50"
                  clearable
                  placeholder="Nhập mã"
              />
          </div>
        </div>
        </div>

        <template slot='footer'>
            <el-button type='text' @click="popupMCmustPay = false">Thoát</el-button>
            <b-overlay
              :show="busy"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block loading-btn"
            >
              <el-button type="primary" v-if="this.repayItem.repayAmount == 0 || this.repayItem.repayMethod == ''" disabled>Thêm</el-button>
              <el-button type='primary' :disabled="busy" @click="addRepayItemHaveExchange(repayItem.repayAmount, repayItem.repayMethod)" v-else>
                  Thêm
              </el-button>
            </b-overlay>
        </template>
    </el-dialog> -->
  </div>
</template>

<script>
import Head from "./components/head.vue"
import BottomPrice from "@/pages/orders-return/components/bottomPrice.vue";
import { OrdersService } from "@/services/nextshop/orders.service"
import { LocationService } from "@/services/nextshop/location.service"
import { SettingService } from "@/services/nextshop/setting.service";

import Swal from "sweetalert2"
import { formatHHmmDDMMYYYY } from "../../utils/format";
import { mapGetters } from "vuex";
import _ from "lodash"
import InputMoneyVmodel from "./components/inputMoneyVmodel.vue";

export default {
  name: "orders-return-detail",
  components: {
    Head,
    BottomPrice,
    InputMoneyVmodel
},
  data() {
    return {
      loading: false,
      id: this.$route.params.id,
      inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
      dataItem: [],
      dataLocation: {},
      dataHistory: [],
      statusOrder: [],
      statusActive: 1,
      dataReturn: [],
      dataRepay: [],
      dataReturnOrder: [],
      par: {},
      gatewayTransactionId: "",
      refundPolicy: false,
      repayTotal: 0,        // tổng phải hoàn
      repayNetSubTotal: 0,  // đã thanh toán
      repayRemain: 0,       // tiền còn lại

      isReceivedItem: false,
      totalPaidAmount: 0,

      formattedPaymentOrderNos: "",

      popupCancelRO: false,
      popupRepay: false,
      popupConfirmItemReceived: false,
      activeTab: 'first',

      customerPayMethodList: [
        {
          text: "Tiền mặt",
          value: "CASH",
        },
        {
          text: "Chuyển khoản",
          value: "BANK_TRANSFER",
        },
        {
          text: "Quẹt thẻ",
          value: "SWIPE",
        },
        {
          text: "MPOS",
          value: "MPOS",
        }
      ],

      merchantPayMethodList: [
        {
          text: "Tiền mặt",
          value: "CASH",
        },
        {
          text: "Chuyển khoản",
          value: "BANK_TRANSFER",
        }
      ],

      customerPayMoney: {
        method: '',
        value: 0,
        gateway: ''
      },

      merchantPayMoney: {
        method: '',
        value: 0,
        gateway: ''
      },

      repayItem: {
        date: '',
        name: '',
        repayAmount: '',
        repayMethod: '',
        gatewayTransactionId: ''
      },
      busy: false,

      updateUI: 1,
      fields: [
        {
          key: "stt",
          label: "#",
          thStyle: { width: "3%", "max-width": "10px" },
        },
        {
          key: "sku",
          label: "Mã SKU",
          thStyle: { width: "3%", "min-width": "100px" },
        },
        {
          key: "itemName",
          label: "Phiên bản sản phẩm",
          thStyle: {
            width: "3%",
            "min-width": "150px" 
          },
        },
        {
          key: "quantity",
          label: "Số lượng",
          thStyle: { width: "3%", "min-width": "50" },
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "price",
          label: "Giá hàng trả",
          thStyle: { width: "3%", "min-width": "100px" },
          thClass: "text-right",
          tdClass: "text-right"
        },
        {
          key: "total",
          label: "Thành tiền",
          thStyle: { width: "3%", "min-width": "100px" },
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      popupMCmustPay: false,
      popupCTmustPay: false,
      orderHaveExchangeItem: false,
      dataReturnHaveExchangeItem: [],
      dataReturnHaveExchange: {},
      
      // caculator
      tax: 0,
      taxAmount: 0,
      discont: 0,
      discontAmount: 0,
      totalAmount: 0,
      totalQuantity: 0,
      feeAmount: 0,
      customerMustPay: 0,
      customerMustPayMoney: 0,
      refund: 0,
      refundType: '',
      temporaryAmount: 0
    }
  },

  async created() {
    this.loading = true
    this.getMainApiMerchantReturn();
    this.getDetailRO()
    this.getDataLocation()
    this.loading = false
  },

  filters: {
    formatPercent(value) {
      return Math.floor(value * 100);
    },
  },


  methods: {
    async getDetailRO() {
      this.statusOrder = []
      this.loading = true
      try {
      const response = await OrdersService.getDetailOrdersReturn(this.id)
      if (response.success) {
        this.loading = false

        this.dataItem = response.data.data
        //check have exchange item
        if (response.data.data.furtherInstructions[0].params.isExchanged == 'true') {
          this.orderHaveExchangeItem = true;
          this.refundType = response.data.data.furtherInstructions[0].params.refundType
          let exchangeOrderId = response.data.data.furtherInstructions[0].params.exchangeOrderId
          this.getDetailExchangeOrder(exchangeOrderId)
        } 
        // trạng thái đơn hàng
        const checkStatusDraft = this.dataItem.statusHistory.find(status =>  status.processorStatus === 'DRAFT')
        if(checkStatusDraft) {
          const draft = {
            ...checkStatusDraft,
            statusTitle: "Tạo đơn",
            description: formatHHmmDDMMYYYY(checkStatusDraft.modifiedAt)
          }
          this.statusOrder.push(draft)
        }
        const checkStatusComplete = this.dataItem.statusHistory.find(status => status.processorStatus == 'COMPLETE')
        if(checkStatusComplete) {
          const complete = {
            ...checkStatusComplete,
            statusTitle: "Hoàn thành",
            description: formatHHmmDDMMYYYY(checkStatusComplete.modifiedAt)
          }
          this.statusActive = 2;
          this.statusOrder.push(complete)
        }
        const checkStatusCanccel = this.dataItem.statusHistory.find(status => status.processorStatus == 'CANCEL')
        if(checkStatusCanccel) {
          const cancel = {
            ...checkStatusCanccel,
            statusTitle: "Đã hủy",
            description: formatHHmmDDMMYYYY(checkStatusCanccel.modifiedAt)
          }
          this.statusOrder.push(cancel)
        }

        if (checkStatusDraft && !checkStatusComplete && !checkStatusCanccel) {
          const complete = {
            statusTitle: "Hoàn thành",
          }
          this.statusOrder.push(complete)
        }

        // lịch sử thao tác
        const rawDataHistory = this.dataItem.furtherInstructions.filter(e => e.key == "ACTION_HISTORY")
          const dataHistoryFormatted = rawDataHistory[0].params.actionsHistory.split("\\").join("")
  
          this.dataHistory = JSON.parse(dataHistoryFormatted).map(e => {
            return {
              ...e,
              modifiedAt: formatHHmmDDMMYYYY(e.modifiedAt),
            }
          })
  
          this.dataHistory.filter((e) => {
            switch(e.action) {
              case "CREATE":
                e.action = "Tạo đơn"
                break
              case "UPDATE_PAYMENT":
                e.action = "Cập nhật thanh toán"
                break
              case "RECEIVED_ITEM":
                e.action = "Xác nhận đã nhận hàng"
                break
              case "SUCCESS":
                e.action = "Hoàn thành"
                break
              case "CANCEL":
                e.action = "Hủy"
                break
              case "COMPLETE" :
                e.action = "Hoàn thành"
            }
          })
        
        // sản phẩm trả
        if (this.dataItem.lineItem.length > 0) {
          this.temporaryAmount = 0
          this.dataReturn = this.mergeLineItemLoHsd(_.cloneDeep(this.dataItem.lineItem)).map(e => {
            let productFeeValue = 0;
            if( e.addedAmount.length > 0 ) {
              productFeeValue = e.addedAmount[0].amount
            } 

            // series
            if (e.lineItemOtherInfo.seriesNo && e.lineItemOtherInfo.seriesNo.length > 0) {
              e.useImeiAndSerial = true;
              e._showDetails = true;
              e.seriesNoTmp = [];
              e.getSeri = [];
            }

            // lo HSD
            if (e.lineItemOtherInfo.productBatch && e.lineItemOtherInfo.productBatch != null) {
              e.useProductBatch = true;
              e._showDetails = true;
            }

            this.temporaryAmount += (e.unitPrice * e.quantity) / 1000 + (productFeeValue * e.quantity) / 1000
            return {
              ...e,
              sku: e.itemInstance.moreInformation.sku,
              name: e.itemInstance.name,
              quantity: e.quantity,
              unitPrice: e.unitPrice,
              itemTotalPrice: e.unitPrice * e.quantity,
              productFeeValue: productFeeValue,
            }
          })
        }
        
        if (this.dataItem.furtherInstructions.length > 0) {
          this.dataReturnOrder = this.dataItem.furtherInstructions.filter(e => {
            if (e.key == 'RETURN_ORDER') {
              return {
                ...e,
                isReceivedItem: e.params.isReceivedItem === 'true' ? true : false,
                totalPaidAmount: e.params.totalPaidAmount,           
              }
            }
          })

          this.par = this.dataReturnOrder[0].params ?? {}
          this.isReceivedItem = this.dataReturnOrder[0].params.isReceivedItem == "true" ? true : false
          this.totalPaidAmount = this.dataReturnOrder[0].totalPaidAmount
        }

        // hoàn tiền cho khách
        this.repayTotal = this.dataItem.lineItemFinalizing.finalAmount
        if (this.dataItem.outcomes.length > 0) {
          this.dataRepay = this.dataItem.outcomes.map(e => {
            return {
              ...e,
              name: e.params.employeeName,
              payMethod: e.params.payMethod,
              payGateway: e.params.payGateway,
              amount: e.params.amount,
              refCode: e.params.gatewayTransactionId,
              date: formatHHmmDDMMYYYY(e.params.requestAt)
            }
          })
          this.repayNetSubTotal = this.dataItem.furtherInstructions[0].params.totalPaidAmount
          this.repayRemain = this.repayTotal - this.repayNetSubTotal
        } else {
          this.repayTotal = 0
          this.repayNetSubTotal = 0
          this.repayRemain = 0
        }
      }
      
      // format payment order no
      this.formattedPaymentOrderNos = this.dataItem.furtherInstructions[0].params.paymentOrderNos.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')

      const locationToCreate = response.data.locationToCreate
      if (locationToCreate != "") {
        this.getDataLocation(locationToCreate)
      }
      } catch (error) {
      console.log(error);
      }
    },

    async getDetailExchangeOrder(exchangeOrderId) {
          const res = await OrdersService.getOrderById(exchangeOrderId);
          if (res.success && res.data.id != "") {
            this.dataReturnHaveExchange = res.data;
            this.dataReturnHaveExchangeItem = this.mergeLineItemLoHsd(_.cloneDeep(res.data.lineItem)).map(e => {
              let productFeeValue = 0;
              if( e.addedAmount.length > 0 ) {
                productFeeValue = e.addedAmount[0].amount
              } 

              // series
              if (e.lineItemOtherInfo.seriesNo && e.lineItemOtherInfo.seriesNo.length > 0) {
                e.useImeiAndSerial = true;
                e._showDetails = true;
                e.seriesNoTmp = [];
                e.getSeri = [];
              }

              // lo HSD
              if (e.lineItemOtherInfo.productBatch && e.lineItemOtherInfo.productBatch != null) {
                e.useProductBatch = true;
                e._showDetails = true;
              }

              return {
                ...e,
                sku: e.itemInstance.moreInformation.sku,
                name: e.itemInstance.name,
                quantity: e.quantity,
                unitPrice: e.unitPrice,
                itemTotalPrice: e.unitPrice * e.quantity,
                productFeeValue: productFeeValue,
              }
            })
            this.calculateData(this.dataReturnHaveExchange);
          }
    },

    calculateData({ lineItemFinalizing, outcomes, lineItemAgg }) {
      const { finalAmount, netSubTotal, addedFee } = lineItemFinalizing;
      addedFee.map((e) => {
        // TAX
        if (e.key == "TAX_ALL") {
          this.taxAmount = +e.amount;
        }

        // discount
        if (e.key == "DISCOUNT_ALL") {
          this.discontAmount = Math.abs(+e.amount);
          this.discont = this.discontAmount / netSubTotal;
        }

        // fee
        if (e.key == "OTHER_FEE") {
          this.feeAmount = +e.amount;
        }
      });
      this.tax = this.taxAmount / (netSubTotal - this.discontAmount);

      this.totalAmount = +netSubTotal;
      this.customerMustPay = +finalAmount;

      // customerPayMoney
      let totalCustomerPayMoney = 0;
      outcomes.map((e) => {
        let price = 0;
        if (e.params.status == "SUCCESS") {
          price = +e.params.amount;
        }
        totalCustomerPayMoney += price;
      });
      this.customerMustPayMoney = totalCustomerPayMoney;

      this.refund = this.customerMustPayMoney - this.customerMustPay;

      lineItemAgg.quantityAgg.forEach((e) => {
        this.totalQuantity += e.quantity;
      });
    },

    async getDataLocation(locationId) {
      try {
        const response = await LocationService.getDetailLocation(
          {locationId: locationId}
        )
        if (response.success) {
          this.dataLocation = response.data
        }
      } catch (error) {
        console.log(error)
      }
    },

    async cancelRO() {
      this.busy = true
      try {
        const response = await OrdersService.cancelOrderReturn(
          {"returnOrderId": `${this.dataItem.id}`}
        )
        if (response.success) {
          this.popupCancelRO = false;
          Swal.fire({
            title: "Thành công",
            text: `Hủy đơn trả hàng thành công`,
            icon: "success",
            confirmButtonText: "Xác nhận",
          }).then(() => {
            this.getDetailRO();
            });
        } else {
          Swal.fire({
            title: "Thất bại",
            text: `Hủy đơn trả hàng thất bại`,
            icon: "warning",
            cancelButtonText: "Hủy",
          })
        }
      } catch (error) {
        console.log(error)
      }
      this.busy = false;
    },

    async btnConfirmReceivedItem() {
      this.busy = true;
      if (this.orderHaveExchangeItem) {
        try {
          const response = await OrdersService.updateExchangeReturnOrder({"orderId": this.dataItem.id, "isReceivedItem": true})
          if(response.success) {
            this.popupConfirmItemReceived = false;
            Swal.fire({
              icon: 'success',
              title: '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
              html:'<span style="color:#9093A4; font-size: 14px;" >Xác nhận đã nhận được hàng trả thành công</span>',
              confirmButtonText: "Xác nhận",
            }).then(()=>{
              this.getDetailRO();
            })
          } 
        } catch (error) {
          console.log(error);
        }
      }
      else {
        try {
          const response = await OrdersService.updateOrderReturn({"orderId": this.dataItem.id, "isReceivedItem": true})
          if(response.success) {
            this.popupConfirmItemReceived = false;
            Swal.fire({
              icon: 'success',
              title: '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
              html:'<span style="color:#9093A4; font-size: 14px;" >Xác nhận đã nhận được hàng trả thành công</span>',
              confirmButtonText: "Xác nhận",
            }).then(()=>{
              this.getDetailRO();
            })
          } 
        } catch (error) {
          console.log(error);
        }
      }
      this.busy = false;
    },

    async changePaymentStatus() {
      this.busy = true;

    },

    getRepayMethod(repayMethod) {
      if (repayMethod == "CASH") {
        return "Tiền mặt"
      } else if (repayMethod == "BANK_TRANSFER") {
        return "Chuyển khoản"
      } else if (repayMethod == "SWIPE") {
        return "Quẹt thẻ"
      }
    },
    
    async addRepayItemHaveExchange(amount, method) {
      this.loading = true
      this.busy = true;
      let param = {
          orderId: this.dataItem.id,
          paymentList: [
            {
              amount: this.checkNumReplaceComma(amount) * 1000,
              isNew: true,
              paymentGateway: "NEXT_SHOP",
              paymentMethod:  method,
              status: "SUCCESS",
              gatewayTransactionId: this.gatewayTransactionId
            },
          ]
      }
      if(method == "SWIPE") {
        param.paymentList[0].paymentGateway = "OTHER"
      } else if (method == "MPOS") {
        param.paymentList[0].paymentGateway = method
        param.paymentList[0].paymentMethod = 'SWIPE'
      }
      try {
        const response = await OrdersService.updateExchangeReturnOrder(param)
        if (response.success) {
          this.popupMCmustPay = false;
          this.popupCTmustPay = false;
          Swal.fire({
            icon: 'success',
            title: '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
            html:'<span style="color:#9093A4; font-size: 14px;" >Hoàn tiền cho khách thành công</span>',
            confirmButtonText: "Xác nhận",
          }).then(()=>{
            this.getDetailRO();
          })
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false
      this.busy = false
      this.gatewayTransactionId = ''
      this.repayItem = {
        date: '',
        name: '',
        repayAmount: '',
        repayMethod: '',
        gatewayTransactionId: ''
      }
    },

     async addRepayItem(amount, method) {
      this.busy = true;
      this.loading = true
        let param = {
          orderId: this.dataItem.id,
          paymentList: [
            {
              amount: this.checkNumReplaceComma(amount) * 1000,
              isNew: true,
              paymentGateway: "NEXT_SHOP",
              paymentMethod: method,
              status: "SUCCESS",
              gatewayTransactionId: this.gatewayTransactionId
            },
          ]
        }
       try {
        const response = await OrdersService.updateOrderReturn(param)
        if (response.success) {
          this.popupRepay = false;
          Swal.fire({
            icon: 'success',
            title: '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
            html:'<span style="color:#9093A4; font-size: 14px;" >Hoàn tiền cho khách thành công</span>',
            confirmButtonText: "Xác nhận",
          }).then(()=>{
            this.getDetailRO();
          })
        }
       } catch (error) {
        console.log(error);
       } finally {
        this.loading = false
       }
    
      this.busy = false
      this.gatewayTransactionId = ''
      this.repayItem = {
        date: '',
        name: '',
        repayAmount: '',
        repayMethod: '',
        gatewayTransactionId: ''
      }
    },


    // tabClick(tab, event) {
    // },

    inputMoney() {
      this.repayItem.repayAmount = this.formatMoneyNotUnit(this.repayItem.repayAmount)
    },

    checkMaxValue(val) {
      let maxValue = this.totalAmountToPay - this.repayNetSubTotal / 1000
      if ( this.checkNumReplaceComma(val) > maxValue) {
        this.repayItem.repayAmount = this.formatMoneyNotUnit(maxValue)
      }
    },

    async getMainApiMerchantReturn() {
      try {
        const response = await SettingService.mainApiMerchant();
        if (response.success) {
          this.refundPolicy = response.data.refundPolicy === "REFUND" ? true : false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    // checkProductBatchOrImeiAndSerial(product) {
    //   if(product.lineItemOtherInfo.seriesNo && product.lineItemOtherInfo.seriesNo.length > 0) {
    //     return product.lineItemOtherInfo.seriesNo[0];
    //   }
    //   else if(product.lineItemOtherInfo.productBatch && product.lineItemOtherInfo.productBatch != null) {
    //     return product.lineItemOtherInfo.productBatch
    //   }
    // },
    checkEmpty(val) {
      if (val == "" || val == null || val == undefined) {
        return " - "
      } else {
        return val
      }
    },

    // checkShowImeiOrProductBatch(product) {
    //   if(product.lineItemOtherInfo.seriesNo && product.lineItemOtherInfo.seriesNo.length > 0) {
    //     return true;
    //   }
    //   else if(product.lineItemOtherInfo.productBatch && product.lineItemOtherInfo.productBatch != null) {
    //     return true;
    //   } else return false;
    // },

    linkTo() {
      this.$router.push({ path: `/pos/pos-detail/${this.dataItem.furtherInstructions[0].params.soOrderId}`})
    },

  },

  computed: {
    ...mapGetters(["getReturnPrice", "getExchangePrice"]),
    getRepayRemain() {
      this.repayRemain = this.dataItem.lineItemFinalizing.finalAmount / 1000 - (this.repayNetSubTotal ? this.repayNetSubTotal / 1000 : 0)
      return this.repayRemain
    },

    returnPrice() {
      return this.dataItem.lineItemFinalizing.finalAmount / 1000
    },

    exchangePrice() {
      return this.customerMustPay / 1000
    },

    totalAmountToPay() {
      return Math.abs(this.returnPrice - this.exchangePrice)
    },

    willCustomerPay() {
      return this.exchangePrice - this.returnPrice > 0 ? true : false
    }
  },
}

</script>

<style lang="scss" scoped>
.boxProgress {
  display: flex;
  justify-content: center;
  // margin: 100px auto 0;
  .el-steps.el-steps--horizontal {
    .el-step.is-horizontal {
      flex-basis: unset;
      margin-right: initial;
      width: 350px;
    }

    .el-step {
      .el-step__description {
        margin: 10px 0;
      }
    }
  }
}
.boxContent {
  margin: 12px 0;
}
.boxContentExt {
  .__card {
    width: 100%;
    max-width: 960px;
    margin: auto;
    max-width: 960px;
    background: #ffffff;
    -webkit-box-shadow: 0px 0px 12px -4px rgba(0, 0, 0, 0.08), 0px 8px 12px -8px rgba(0, 0, 0, 0.16);
    box-shadow: 0px 0px 12px -4px rgba(0, 0, 0, 0.08), 0px 8px 12px -8px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    padding: 24px;
  }

  .__card_title{
    font-style: normal;
    font-weight: bold!important;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: -0.01em;
    color: #23313e;
  }
}

.product-batch-or-imei {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.product-batch-or-imei span {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2px 8px;
  gap: 4px;
  width: 100px;
  height: 32px;
  background: #F2F3F4;
  border-radius: 4px;
  flex: none;
  order: 0;
  flex-grow: 0;
}


.loading-btn {
    margin-left: 30px;
}

.payment-info {
  width: 750px;
  background: #F2F3F4;
  box-shadow: 0px -1px 0px #DDDDDD;
  margin: 15px 2px;
  padding: 4px;
  border: 1px solid #DDDDDD;
  border-radius: 8px;
  line-height: 160%;
}

.payment-info div {
  border-bottom: 1.5px solid #DDDDDD;
  margin: 0 -4px;
  padding: 8px 0;
}

.payment-info div:last-child {
  border: none;
}

.payment-status {
  display: flex;
  justify-content: center;
}

.payment-status div:nth-child(2){
  padding: 0 10px;
}

.payment-status span {
  margin-left: 10px;
}

.total-paid-amount-left span {
    color: red;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
}

.total-paid-amount-left span:first-child {
    color: black;
}

.fee-value {
  font-size: 11px;
  color: #f83939;
  position: absolute;
  pointer-events: none;
  z-index: 1;
  display: flex;
  right: 0;
}

.boxProgress {
  margin-top: 90px;
}

.MPOS-payment {
  margin: 10px 0 0 0;
  padding: 16px;
  background: #FFF9EC;
  border: 1px solid #FFC043;
  box-shadow: 0px 10px 24px rgb(18 38 63 / 5%);
  color: #000;
}

::v-deep .el-table thead tr th{
  background: #F2F3F4 ;
  color: #23313E;
}

::v-deep .el-dialog {
  .el-dialog__body {
    .el-form-item {
      .el-form-item__label {
        margin-bottom: 0;
      }
    }
  }
}
</style>

<style lang="scss">
.order-detail-88 {
  .el-tabs__item {
    font-size: 20px;
    font-weight: 600;
    color: #ddd;
  }
  .el-tabs__item.is-active {
    color: #23313e;
  }

  .el-tabs__header {
    margin: 0 0 24px;
  }
  
  .table td{
    height: 68px;
  }
  .select-item {
    display: inline-block;
    background-color: #F2F3F4;
    padding: 6px;
    margin: 0 10px 10px 10px;
    border-radius: 4px;
  }
  .border-top {
    border-top: 1px solid rgb(242, 243, 244);
  }
}
</style>